import { render } from "./Auction.vue?vue&type=template&id=2632c7c0"
import script from "./Auction.vue?vue&type=script&lang=js"
export * from "./Auction.vue?vue&type=script&lang=js"
script.render = render

export default script